export default {
  locale: 'pt-BR',
  formats: {
    number: {
      BRL: {
        style: 'currency',
        currency: 'BRL',
        minimiumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    }
  }
}
